import { Pipe, PipeTransform } from "@angular/core";
import { last, toLower } from "lodash-es";

@Pipe({
  name: "iconByFileType",
  standalone: false
})
export class IconByFileTypePipe implements PipeTransform {
  transform(fileName: string | undefined): string {
    if (!fileName) {
      return "fa-file-circle-question";
    }

    const extension = toLower(last(fileName.split(".")));

    switch (extension) {
      case "pdf": {
        return "fa-file-pdf";
      }
      case "mp4":
      case "mov":
      case "ogv":
      case "flv":
      case "mkv":
      case "avi": {
        return "fa-file-video";
      }
      case "ogg":
      case "aac":
      case "wav":
      case "mp3": {
        return "fa-file-music";
      }
      case "tar":
      case "gzip":
      case "zip": {
        return "fa-file-zipper";
      }
      case "gif":
      case "tiff":
      case "jpg":
      case "png":
      case "jpeg": {
        return "fa-file-image";
      }
      case "csv": {
        return "fa-file-csv";
      }
      case "xlsx":
      case "xls": {
        return "fa-file-excel";
      }
      case "docx":
      case "doc": {
        return "fa-file-word";
      }
      default: {
        return "fa-file";
      }
    }
  }
}
